/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var travelSite = site.travel;
    MoyaComponents.register('travel.vakinn', function (el) {
        var vakinn = new Vakinn(el);
        vakinn.run();
    });
    var Vakinn = /** @class */ (function () {
        function Vakinn(el) {
            this.el = el;
            this.current = '';
        }
        Vakinn.prototype.run = function () {
            this.bindControlButtons();
            this.bindCategoryButtons();
            this.bindSelected();
        };
        Vakinn.prototype.bindControlButtons = function () {
            var _this = this;
            this.el.querySelectorAll('.travel__results button').forEach(function (btn) {
                util.delegate(btn, 'click', 'button', function (e) {
                    e.preventDefault();
                    _this.hideSubFilters();
                    _this.resetTravelServices();
                    _this.uncheckOtherButtons(btn);
                    _this.setSelected(document.createElement('button'));
                    var parentKey = e.target.getAttribute('data-parent-key');
                    if (parentKey === _this.current) {
                        _this.current = '';
                        _this.hideSubFilters();
                    }
                    else {
                        _this.current = parentKey;
                        _this.openSubFilterWithIds();
                    }
                    _this.updateResultCount();
                });
            });
        };
        Vakinn.prototype.openSubFilterWithIds = function () {
            var _this = this;
            this.el.querySelectorAll('.sub_filters').forEach(function (item) {
                var parentKey = item.dataset.parentKey;
                if (parentKey === _this.current) {
                    item.classList.add('open');
                }
            });
        };
        Vakinn.prototype.hideSubFilters = function () {
            this.el.querySelectorAll('.sub_filters').forEach(function (item) {
                item.classList.remove('open');
            });
        };
        Vakinn.prototype.bindCategoryButtons = function () {
            var _this = this;
            this.el.querySelectorAll('.sub_filter_wrap button').forEach(function (btn) {
                util.delegate(btn, 'click', 'button', function () {
                    _this.resetTravelServices();
                    _this.hideNonCategoryService(btn.dataset.category);
                    _this.updateResultCount();
                    _this.setSelected(btn);
                    btn.parentElement.parentElement.classList.remove('open');
                    _this.updateMap(btn);
                });
            });
        };
        Vakinn.prototype.resetTravelServices = function () {
            document.querySelectorAll('.travel__services .travel__service').forEach(function (item) {
                item.classList.remove('hide');
            });
        };
        Vakinn.prototype.hideNonCategoryService = function (category) {
            document.querySelectorAll('.travel__services .travel__service').forEach(function (item) {
                var serviceCategory = JSON.parse(item.dataset.category);
                if (!serviceCategory.includes(category)) {
                    item.classList.add('hide');
                }
            });
        };
        Vakinn.prototype.updateResultCount = function () {
            var length = document.querySelectorAll('.travel__services .travel__service:not(.hide)').length;
            document.querySelector('.resultss span span').innerHTML = String(length);
        };
        Vakinn.prototype.uncheckOtherButtons = function (btn) {
            var _this = this;
            setTimeout(function () {
                _this.el.querySelectorAll('.travel__results button').forEach(function (item) {
                    if (item.dataset.parentKey !== btn.dataset.parentKey) {
                        item.classList.remove('checked');
                    }
                });
            }, 440);
        };
        Vakinn.prototype.setSelected = function (btn) {
            document.querySelector('.resultss .selected').innerHTML = btn.innerHTML;
        };
        Vakinn.prototype.bindSelected = function () {
            var _this = this;
            util.delegate(this.el.parentElement, 'click', '.resultss .selected', function (e) {
                var target = e.delegateTarget;
                target.innerHTML = '';
                _this.resetTravelServices();
                _this.el.querySelectorAll('.travel__results button').forEach(function (btn) {
                    btn.classList.remove('checked');
                });
                _this.updateResultCount();
                _this.updateMap(document.createElement('button'));
                _this.current = '';
            });
        };
        Vakinn.prototype.updateMap = function (btn) {
            var newMarkers = [];
            var options = document.querySelector('.travel__gmap').getAttribute('data-map-options');
            var mapOptions = moya.map.getMapOptions(JSON.parse(options));
            for (var i = 0; i < travelSite.allMarkers.length; i++) {
                var marker = travelSite.allMarkers[i];
                marker.position = marker.options.position.lat + ',' + marker.options.position.lng;
                var show = false;
                var category = btn.dataset.category;
                if (marker.options.hasOwnProperty('tags') &&
                    marker.options.tags.includes(category)) {
                    show = true;
                }
                else if (marker.options.hasOwnProperty('options') &&
                    marker.options.options.hasOwnProperty('tags') &&
                    marker.options.options.tags.includes(category)) {
                    show = true;
                }
                if (show) {
                    newMarkers.push(marker);
                }
            }
            if (newMarkers.length > 0) {
                travelSite.clearMap();
                moya.map.markers = moya.map.addMarkers(newMarkers, moya.map.osmMap, mapOptions);
                moya.map.fitMarkers();
                site.travel.rebindMarkerPopups();
            }
            else {
                travelSite.clearMap();
                moya.map.markers = moya.map.addMarkers(site.travel.allMarkers, moya.map.osmMap, mapOptions);
                moya.map.fitMarkers();
                travelSite.rebindMarkerPopups();
            }
        };
        return Vakinn;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
